export const APP_NAME = 'PRIMESOFT BUSINESS'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const RECAPTCHA_APP_SITE_KEY = process.env.NODE_ENV==='development' ? '6Ld2TlEUAAAAANfer9I1xq1YbV-sJhctjmAOc-FP' : '6Lcu7ZYlAAAAAMOh5saZmTji16q6CK-XhnqVKgIB'
